import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"

import { BulletListWithIcon, BoilerBlob } from "../../../../Shared"

import {
  calculateOrderPayments,
  convertPriceToPounds,
} from "../../../../../utilities"

export const Boiler = ({
  award,
  label,
  bullets,
  interestRate,
  name,
  photo,
  tagline,
  totalPrice,
  urlBookInstallation,
  urlMoreInfo,
  labourCost,
  flueCost,
  vat,
}) => {
  const [loanTerm, setLoanTerm] = React.useState(3)

  const [boilerFinance, setBoilerFinance] = React.useState(() =>
    calculateOrderPayments({
      boilerAmount: parseInt(totalPrice) * 100,
      boilerControlAmount: parseInt(0) * 100,
      code: "finance",
      financeMonths: loanTerm * 12,
      interestRate: interestRate,
      labourCost: parseInt(labourCost) * 100,
      flueCost: parseInt(flueCost) * 100,
      vat: vat,
    })
  )

  React.useEffect(() => {
    setBoilerFinance(() =>
      calculateOrderPayments({
        boilerAmount: parseInt(totalPrice) * 100,
        boilerControlAmount: parseInt(0) * 100,
        code: "finance",
        financeMonths: loanTerm * 12,
        interestRate: interestRate,
        labourCost: parseInt(labourCost) * 100,
        flueCost: parseInt(flueCost) * 100,
        vat: vat,
      })
    )
  }, [loanTerm])

  const boilerUpfront = calculateOrderPayments({
    boilerAmount: parseInt(totalPrice) * 100,
    boilerControlAmount: parseInt(0) * 100,
    code: "up-front",
    financeMonths: 0,
    interestRate: 0,
    labourCost: parseInt(labourCost) * 100,
    flueCost: parseInt(flueCost) * 100,
    vat: vat,
  })

  const updateLoanTerm = (e) => {
    setLoanTerm(e.target.value)
  }
  return (
    <section className="boiler-wrapper">
      {label && <div className="boiler-label">Cheapest for your answers</div>}
      <div className={`boiler${label ? " boiler-border-label" : ""}`}>
        <BoilerBlob
          blobColor="blue-light"
          photo={photo}
          photoDesc={name}
          useGraphql={false}
          award={award}
        />
        <div className="boiler-stats">
          <h2 className="heading-large">{name}</h2>
          <p className="boiler-tagline">{tagline}</p>
          <BulletListWithIcon bullets={bullets} />
        </div>
        <div className="boiler-order-details">
          <div className="boiler-pricing">
            <span className="boiler-total-price">
              £{convertPriceToPounds(boilerUpfront.upfrontAmount).toFixed(2)}{" "}
            </span>
            <span className="boiler-total-price-label">
              total price inc. VAT
            </span>
            <div className="boiler-pricing-divider">
              <span className="boiler-pricing-divider-line"></span>
              <span className="boiler-pricing-divider-text">or</span>
              <span className="boiler-pricing-divider-line"></span>
            </div>
            <span className="boiler-pricing-monthly">
              £{convertPriceToPounds(boilerFinance.monthlyRepayment).toFixed(2)}{" "}
              a month
            </span>
            <div className="boiler-pricing-loan">
              ({interestRate}% APR) for
              <div className="boiler-pricing-loan-term-wrapper">
                <select
                  className="boiler-pricing-loan-term"
                  value={loanTerm}
                  onChange={updateLoanTerm}
                >
                  <option value={3}>3 years</option>
                  <option value={5}>5 years</option>
                  <option value={8}>8 years</option>
                </select>
                <span className="icon-wedge"></span>
              </div>
            </div>
          </div>
          <div className="boiler-actions">
            <Link to={urlBookInstallation} className="button-primary">
              Book installation
            </Link>
            <Link to={urlMoreInfo} className="button-secondary">
              More information
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

Boiler.defaultProps = {
  award: "",
}

Boiler.propTypes = {
  award: PropTypes.string,
  label: PropTypes.bool.isRequired,
  boilerId: PropTypes.string.isRequired,
  bullets: PropTypes.array.isRequired,
  contentfulId: PropTypes.string.isRequired,
  interestRate: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  tagline: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  urlMoreInfo: PropTypes.string.isRequired,
}
